import React, { useContext, useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Box, Button, Grid, makeStyles } from "@material-ui/core/";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import DnerhsApi from "../../api/DnerhsApi";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Link, useParams } from "react-router-dom";
import UserContext from "../../context/User/UserContext";
import AdjuntosDialog from "../../dialogs/AdjuntosDialog";
import commonMethods from "../../utils/commonMethods";
import history from "../../utils/History";
import Alert from "../../components/Alert";

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(),
  },
}));

const List = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [tipoDoc, setTipoDoc] = useState();
  const [
    idAneaesCertificadoInicioProceso,
    setIdAneaesCertificadoInicioProceso,
  ] = useState("");
  const [idAneaesPlanMejoras, setIdAneaesPlanMejoras] = useState("");
  const [
    idAneaesRespaldoProcesoEvaluacion,
    setIdAneaesRespaldoProcesoEvaluacion,
  ] = useState("");
  const [
    idConesResolucionRegistroOfertasAcademicas,
    setIdConesResolucionRegistroOfertasAcademicas,
  ] = useState("");
  const [idConstanciaGestionConvenio, setIdConstanciaGestionConvenio] =
    useState("");
    //nuevos
         //5
         const [
          resolucionAranceles,
          setResolucionAranceles,
        ] = useState("");
        //6
    const [
      resolucionHabilitacionMec,
      setResolucionHabilitacionMec,
    ] = useState("");
        //7
    const [
      resolucionHabilitacionCones,
      setResolucionHabilitacionCones,
    ] = useState("");
       //8
    const [
      constanciaInicioProcesoCones,
      setConstanciaInicioProcesoCones,
    ] = useState("");
       //9
    const [
      constanciaActualizacionCarreraCones,
      setConstanciaActualizacionCarreraCones,
    ] = useState("");
      //10
    const [
      resolucionAcreditacionInicioProcesoAneaes,
      setResolucionAcreditacionInicioProcesoAneaes,
    ] = useState("");
      //11
    const [
      evaluacionDiagnosticaPlanImplementaciónAneaes,
      setEvaluacionDiagnosticaPlanImplementaciónAneaes,
    ] = useState("");
      //12
    const [
      inscripcionProcesoEvaluaciónAneaes,
      setInscripcionProcesoEvaluaciónAneaes,
    ] = useState("");
    //13
    const [
      resolucionHabilitacionPostgradoCones,
      setResolucionHabilitacionPostgradoCones,
    ] = useState("");
    //14
    const [
      constanciaGestionConvenioPostgradoCones,
      setConstanciaGestionConvenioPostgradoCones,
    ] = useState("");
    //15
    const [
      certificadoProcesoAcreditacionPostgradoAneaes,
      setCertificadoProcesoAcreditacionPostgradoAneaes,
    ] = useState("");
    //16
    const [
      evaluacionDiagnosticaPostgradoAneaes,
      setEvaluacionDiagnosticaPostgradoAneaes,
    ] = useState("");
    //17
    const [
      planImplementacionMejorasPostgradoAneaes,
      setPlanImplementacionMejorasPostgradoAneaes,
    ] = useState("");
    const [
      informeSemestralIF,
      setInformeSemestralIF,
    ] = useState("");
    const [
      listadoAlumnos,
      setListadoAlumnos,
    ] = useState("");
    const [
      resolucionBecados,
      setResolucionBecados,
    ] = useState("");
    
    const [isPrimerConvenio, setIsPrimerConvenio] = useState(false);
    const [institucionF, setInstitucionF] = useState(false);

    //
  const [responseDocumentosData, setResponseDocumentosData] = useState({});
  const { userData } = useContext(UserContext);
  const [isUpdate, setIsUpdate] = useState(false);
  const isAdmin = userData && userData.role.descripcion === "ROLE_ADMIN";
  const params = useParams();
  const [categoria, setCategoria] = useState();
  const docsRespaldo = [
    {
      id: 1,
      descripcion:
        "ANEAES Certificado de inicio del proceso de Acreditación de la Entidad pertinente",
    },
    {
      id: 2,
      descripcion:
        "ANEAES Documento de respaldo del proceso de Evaluación Diagnóstica de la Entidad pertinente",
    },
    {
      id: 3,
      descripcion:
        "ANEAES Plan de implementación de las mejoras o modificaciones indicadas en la evaluación diagnóstica",
    },
    {
      id: 4,
      descripcion:
        "CONES Resolución de habilitación, actualización y/o inserción en el registro nacional de ofertas académicas",
    },
    {
      id: 5,
      descripcion:
        "Constancia provisoria para la gestión del Convenio con el MSPyBS, con el parecer favorable del CONES para Programas de Postgrado y sedes en proceso de habilitación",
    },
  ];
  const docsRespaldoPregrado = [
    
    {
      id: 4,
      descripcion:
        "Copia de la Resolución de habilitación emitida por el MEC.",
    },{
      id: 5,
      descripcion:
        "Resolucion de Aranceles",
    },{
      id: 6,
      descripcion:
        "Informe Semestral de Institución Formadora.",
    },

  ];
  const docsRespaldoGradoCones = [
    {
      id: 7,
      descripcion:
        "Copia de la Resolución de habilitación emitida por CONES."
    },
    {
      id: 8,
      descripcion:
        "En caso de no contar con la Resolución de habilitación, presentar constancia que certifique el inicio de proceso de habilitación.",
    },
    {
      id: 9,
      descripcion:
        "En caso de actualización de la carrera de grado, presentar constancia que certifique el proceso.",
    }
  ];
  const docsRespaldoGradoAneaes = [
    {
      id: 10,
      descripcion:
        "Para aquellas instituciones cuyas carreras cuenten con la primera cohorte de egresados: Presentar copia de resolución de acreditación o constancia de haber iniciado el proceso de acreditación."
    },
    {
      id: 11,
      descripcion:
        "Para aquellas Instituciones Formadoras con más de dos (2) años de habilitación de la carrera: Presentar contrato de Evaluación Diagnóstica y copia del Plan de implementación de las mejoras o modificaciones indicadas en la evaluación diagnóstica.",
    },
    {
      id: 12,
      descripcion:
        "Aquella INSTITUCIÓN FORMADORA cuyo periodo de acreditación haya finalizado, deberá presentar la inscripción al proceso de evaluación con fines de acreditación en la convocatoria que realice la ANEAES.",
    }
  ];
  
  const docsRespaldoPostgradoCones = [
    {
      id: 13,
      descripcion:
        "Resolución de habilitación, actualización y/o inserción en el registro nacional de ofertas académicas del CONES.",
    },
    {
      id: 14,
      descripcion:
        "Constancia provisoria para la gestión del Convenio con el MSPyBS, con el parecer favorable del CONES para Programas de Postgrado y sedes en proceso de habilitación.",
    }
  ];
  const docsRespaldoPostgradoAneaes = [
    {
      id: 15,
      descripcion:
        "Copia del Certificado de inicio del proceso de Acreditación de la Entidad pertinente (ANEAES) para los Programas de Postgrado que cuentan con Modelo Nacional y ya tienen egresados.",
    },
    {
      id: 16,
      descripcion:
        "Copia del documento que respalda el proceso de Evaluación Diagnóstica de la Entidad pertinente para los Programas de Postgrado que aún no cuentan con egresados.",
    },
    {
      id: 17,
      descripcion:
        "Copia del Plan de implementación de las mejoras o modificaciones indicadas en la evaluación diagnóstica.",
    }
  ];
  const docsRespaldoGradoOtros = [
    {
      id: 18,
      descripcion:
        "Resolucion de Aranceles."
    },{
      id: 19,
      descripcion:
        "Informe Semestral de Institución Formadora."
    }
  ];
  const docsRespaldoProstgradoOtros = [
    {
      id: 20,
      descripcion:
        "Resolucion de Aranceles."
    },{
      id: 21,
      descripcion:
        "Informe Semestral de Institución Formadora."
    }
  ];
  const docsRespaldoAlumnos = [
    {
      id: 22,
      descripcion:
        "Listado de Alumnos."
    },{
      id: 23,
      descripcion:
        "Resolución de Becados."
    }
  ];
  useEffect(() => {
    const load = () => {
      try {
        getServerData();
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const getServerData = async () => {
    try {

      let url = `/convenios/${params.convenioId}`;
      const {data : convenioResponseData} = await DnerhsApi(url);
      setCategoria(convenioResponseData.categoria);
      setInstitucionF(convenioResponseData.institucionFormadora.id)
      const {data : responseDocumentosData} = await DnerhsApi.get(
        `/convenios/${params.convenioId}/documentos-respaldo`
      );

      console.log('data - responseDocumentosData', responseDocumentosData);

      if (responseDocumentosData) {
        setResponseDocumentosData(responseDocumentosData);

        setIdAneaesCertificadoInicioProceso(
          responseDocumentosData.aneaesCertificadoInicioProceso
        );
        setIdAneaesPlanMejoras(responseDocumentosData.aneaesPlanMejoras);
        setIdAneaesRespaldoProcesoEvaluacion(
          responseDocumentosData.aneaesRespaldoProcesoEvaluacion
        );
        setIdConesResolucionRegistroOfertasAcademicas(
          responseDocumentosData.conesResolucionRegistroOfertasAcademicas
        );
        setIdConstanciaGestionConvenio(
          responseDocumentosData.constanciaGestionConvenio
        );

          setResolucionHabilitacionMec(responseDocumentosData.resolucionHabilitacionMec);
          setResolucionHabilitacionCones(responseDocumentosData.resolucionHabilitacionCones);
          setConstanciaInicioProcesoCones(responseDocumentosData.constanciaInicioProcesoCones);
          setConstanciaActualizacionCarreraCones(responseDocumentosData.constanciaActualizacionCarreraCones);
          setResolucionAcreditacionInicioProcesoAneaes(responseDocumentosData.resolucionAcreditacionInicioProcesoAneaes);
          setEvaluacionDiagnosticaPlanImplementaciónAneaes(responseDocumentosData.evaluacionDiagnosticaPlanImplementaciónAneaes);
          setInscripcionProcesoEvaluaciónAneaes(responseDocumentosData.inscripcionProcesoEvaluaciónAneaes);
          setResolucionHabilitacionPostgradoCones(responseDocumentosData.resolucionHabilitacionPostgradoCones);
          setConstanciaGestionConvenioPostgradoCones(responseDocumentosData.constanciaGestionConvenioPostgradoCones);
          setCertificadoProcesoAcreditacionPostgradoAneaes(responseDocumentosData.certificadoProcesoAcreditacionPostgradoAneaes);
          setEvaluacionDiagnosticaPostgradoAneaes(responseDocumentosData.evaluacionDiagnosticaPostgradoAneaes);
          setPlanImplementacionMejorasPostgradoAneaes(responseDocumentosData.planImplementacionMejorasPostgradoAneaes);
          setPlanImplementacionMejorasPostgradoAneaes(responseDocumentosData.planImplementacionMejorasPostgradoAneaes);
          setResolucionAranceles(responseDocumentosData.resolucionAranceles);
          setInformeSemestralIF(responseDocumentosData.informeSemestral);
          setListadoAlumnos(responseDocumentosData.listadoAlumnos);
          setResolucionBecados(responseDocumentosData.resolucionBecados);

        setIsUpdate(true);
      }

    } catch (error) {
      console.log("Error al cargar pagina", error);
      if (error.response) {
        Alert.showServerError(error);
      }
    }
  };

  const onSubmit = async (data) => {

    if (
      (categoria === "Pregrado") &&
      (resolucionHabilitacionMec === "" || resolucionHabilitacionMec == null)
    ) {
      Alert.show({
        message: "Es requerido el documento de la Resolucion de Habilitacion MEC.",
        type: "error",
      });
      return;
    }

    if ((categoria === "Grado") &&
      (resolucionHabilitacionCones === "" ||
      resolucionHabilitacionCones == null) &&
      (constanciaInicioProcesoCones === "" ||
      constanciaInicioProcesoCones == null) &&
        (constanciaActualizacionCarreraCones === "" ||
        constanciaActualizacionCarreraCones == null)
    ) {
      Alert.show({
        message: "Es requerido por lo menos un documento del CONES.",
        type: "error",
      });
      return;
    }
    if ((categoria === "Grado") &&
    (resolucionAcreditacionInicioProcesoAneaes === "" ||
    resolucionAcreditacionInicioProcesoAneaes == null) &&
    (evaluacionDiagnosticaPlanImplementaciónAneaes === "" ||
    evaluacionDiagnosticaPlanImplementaciónAneaes == null) &&
      (inscripcionProcesoEvaluaciónAneaes === "" ||
      inscripcionProcesoEvaluaciónAneaes == null)
  ) {
    Alert.show({
      message: "Es requerido por lo menos un documento de la ANEAES.",
      type: "error",
    });
    return;
  }


  if ((categoria === "Postgrado") &&
      (resolucionHabilitacionPostgradoCones === "" ||
      resolucionHabilitacionPostgradoCones == null) &&
      (constanciaGestionConvenioPostgradoCones === "" ||
      constanciaGestionConvenioPostgradoCones == null)
    ) {
      Alert.show({
        message: "Es requerido por lo menos un documento del CONES.",
        type: "error",
      });
      return;
    }
    if ((categoria === "Postgrado") &&
    (certificadoProcesoAcreditacionPostgradoAneaes === "" ||
    certificadoProcesoAcreditacionPostgradoAneaes == null) &&
    (evaluacionDiagnosticaPostgradoAneaes === "" ||
    evaluacionDiagnosticaPostgradoAneaes == null) &&
      (planImplementacionMejorasPostgradoAneaes === "" ||
      planImplementacionMejorasPostgradoAneaes == null)
    ) {
    Alert.show({
      message: "Es requerido por lo menos un documento de la ANEAES.",
      type: "error",
    });
    return;
    }
    let esPrimerConvenio=false;
       //verificar si es el primer convenio
       
      let urlPrimerConvenio = `/convenios/institucionFormadora/${institucionF}/primer-convenio`; 
      const {data : responsePrimerConvenio} = await DnerhsApi(urlPrimerConvenio);
      if(responsePrimerConvenio?.convenioId.toString()===params.convenioId.toString()){
      esPrimerConvenio=true;
      }else{
              esPrimerConvenio=false;
      }

      if (
       (esPrimerConvenio === false) &&
         (informeSemestralIF === "" ||
         informeSemestralIF == null)
       ) {
        Alert.show({
          message: "Es requerido el documento de Informe Semestral de la Institucion Formadora.",
          type: "error",
        });
        return;
       }

      if (
        (resolucionAranceles === "" ||
        resolucionAranceles == null)
      ) {
        Alert.show({
          message: "Es requerido el Documento de Resolucion de Aranceles.",
          type: "error",
        });
        return;
      }
  
      if (
        (listadoAlumnos === "" ||
        listadoAlumnos == null)
      ) {
        Alert.show({
          message: "Es requerido el Documento: Listado de Alumnos.",
          type: "error",
        });
        return;
      }       

    const payload = {
      /*aneaesCertificadoInicioProceso: idAneaesCertificadoInicioProceso,
      aneaesPlanMejoras: idAneaesPlanMejoras,
      aneaesRespaldoProcesoEvaluacion: idAneaesRespaldoProcesoEvaluacion,
      conesResolucionRegistroOfertasAcademicas:
        idConesResolucionRegistroOfertasAcademicas,
      constanciaGestionConvenio: idConstanciaGestionConvenio,*/
      convenio: {
        id: params.convenioId,
      },
      resolucionHabilitacionMec: resolucionHabilitacionMec,
      resolucionHabilitacionCones: resolucionHabilitacionCones,
      constanciaInicioProcesoCones: constanciaInicioProcesoCones,
      constanciaActualizacionCarreraCones:constanciaActualizacionCarreraCones,
      resolucionAcreditacionInicioProcesoAneaes:resolucionAcreditacionInicioProcesoAneaes,
      evaluacionDiagnosticaPlanImplementaciónAneaes:evaluacionDiagnosticaPlanImplementaciónAneaes,
      inscripcionProcesoEvaluaciónAneaes:inscripcionProcesoEvaluaciónAneaes,
      resolucionHabilitacionPostgradoCones:resolucionHabilitacionPostgradoCones,
      constanciaGestionConvenioPostgradoCones:constanciaGestionConvenioPostgradoCones,
      certificadoProcesoAcreditacionPostgradoAneaes:certificadoProcesoAcreditacionPostgradoAneaes,
      evaluacionDiagnosticaPostgradoAneaes:evaluacionDiagnosticaPostgradoAneaes,
      planImplementacionMejorasPostgradoAneaes:planImplementacionMejorasPostgradoAneaes,
      resolucionAranceles: resolucionAranceles,
      informeSemestral: informeSemestralIF,
      listadoAlumnos: listadoAlumnos,
      resolucionBecados: resolucionBecados
    };

    try {
      let url = "/convenios/documentos-respaldo";
      let message = "";
     
      if (isUpdate) {
       await DnerhsApi.put(url, {
          ...responseDocumentosData,...payload,
        });

        message = "Datos actualizados exitosamente.";
      }else {
       await DnerhsApi.post(url, {
          ...payload,
        });

        message = "Datos guardados exitosamente.";
      }
     
       Alert.show({
         message,
         type : "success"
       })

       history.goBack();

    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      }
    }
  };

  const handleClickOpen = (documento) => {
    setOpen(true);
    setTipoDoc(documento);
  };

  const handleClose = (value) => {
    setOpen(false);
    if (tipoDoc === 1) {
      //setIdAneaesCertificadoInicioProceso(value);
    } else if (tipoDoc === 2) {
      //setIdAneaesRespaldoProcesoEvaluacion(value);
    } else if (tipoDoc ===20) {
      setResolucionAranceles(value);
    } else if (tipoDoc === 18) {
      setResolucionAranceles(value);
      //
    } else if (tipoDoc ===21) {
      setInformeSemestralIF(value);
    } else if (tipoDoc === 19) {
      setInformeSemestralIF(value);
    } else if (tipoDoc === 5) {
      setResolucionAranceles(value);
    }else if (tipoDoc === 4) {
      setResolucionHabilitacionMec(value);
    }else if (tipoDoc === 6) {
      setInformeSemestralIF(value);
    }else if (tipoDoc === 7) {
      setResolucionHabilitacionCones(value);
    }else if (tipoDoc === 8) {
      setConstanciaInicioProcesoCones(value);
    }else if (tipoDoc === 9) {
      setConstanciaActualizacionCarreraCones(value);
    }else if (tipoDoc === 10) {
      setResolucionAcreditacionInicioProcesoAneaes(value);
    }else if (tipoDoc === 11) {
      setEvaluacionDiagnosticaPlanImplementaciónAneaes(value);
    }else if (tipoDoc === 12) {
      setInscripcionProcesoEvaluaciónAneaes(value);
    }else if (tipoDoc === 13) {
      setResolucionHabilitacionPostgradoCones(value);
    }else if (tipoDoc === 14) {
      setConstanciaGestionConvenioPostgradoCones(value);
    }else if (tipoDoc === 15) {
      setCertificadoProcesoAcreditacionPostgradoAneaes(value);
    }else if (tipoDoc === 16) {
      setEvaluacionDiagnosticaPostgradoAneaes(value);
    }else if (tipoDoc === 17) {
      setPlanImplementacionMejorasPostgradoAneaes(value);
    }else if (tipoDoc === 22) {
      setListadoAlumnos(value);
    }else if (tipoDoc === 23) {
      setResolucionBecados(value);
    }
  };

  const disabledDocumentView = (documento) => {
    if (documento.id === 1) {
      return idAneaesCertificadoInicioProceso === "" || idAneaesCertificadoInicioProceso == null;
    } else if (documento.id === 2) {
      return idAneaesRespaldoProcesoEvaluacion === "" || idAneaesRespaldoProcesoEvaluacion == null;
    } else if (documento.id === 3) {
      return idAneaesPlanMejoras === "" || idAneaesPlanMejoras == null;
    } else if (documento.id === 6) {
      return informeSemestralIF === "" || informeSemestralIF == null;
    } else if (documento.id === 5) {
      return resolucionAranceles === "" || resolucionAranceles == null;
    }else if (documento.id === 4) {
      return resolucionHabilitacionMec === "" || resolucionHabilitacionMec == null;
    }else if (documento.id === 7) {
      return resolucionHabilitacionCones === "" || resolucionHabilitacionCones == null;
    }else if (documento.id === 8) {
      return constanciaInicioProcesoCones === "" || constanciaInicioProcesoCones == null;
    }else if (documento.id === 9) {
      return constanciaActualizacionCarreraCones === "" || constanciaActualizacionCarreraCones == null;
    }else if (documento.id === 10) {
      return resolucionAcreditacionInicioProcesoAneaes === "" || resolucionAcreditacionInicioProcesoAneaes == null;
    }else if (documento.id === 11) {
      return evaluacionDiagnosticaPlanImplementaciónAneaes === "" || evaluacionDiagnosticaPlanImplementaciónAneaes == null;
    }else if (documento.id === 12) {
      return inscripcionProcesoEvaluaciónAneaes === "" || inscripcionProcesoEvaluaciónAneaes == null;
    }else if (documento.id === 13) {
      return resolucionHabilitacionPostgradoCones === "" || resolucionHabilitacionPostgradoCones == null;
    }else if (documento.id === 14) {
      return constanciaGestionConvenioPostgradoCones === "" || constanciaGestionConvenioPostgradoCones == null;
    }else if (documento.id === 15) {
      return certificadoProcesoAcreditacionPostgradoAneaes === "" || certificadoProcesoAcreditacionPostgradoAneaes  == null;
    }else if (documento.id === 16) {
      return evaluacionDiagnosticaPostgradoAneaes === "" || evaluacionDiagnosticaPostgradoAneaes == null;
    }else if (documento.id === 17) {
      return planImplementacionMejorasPostgradoAneaes === "" || planImplementacionMejorasPostgradoAneaes == null;
    }else if (documento.id === 18) {
      return resolucionAranceles === "" || resolucionAranceles == null;
    }else if (documento.id === 20) {
      return resolucionAranceles === "" || resolucionAranceles == null;
    }else if (documento.id === 21) {
      return informeSemestralIF === "" || informeSemestralIF == null;
    }else if (documento.id ===19) {
      return informeSemestralIF === "" || informeSemestralIF == null;
    }else if (documento.id ===22) {
      return listadoAlumnos === "" || listadoAlumnos == null;
    }else if (documento.id ===23) {
      return resolucionBecados === "" || resolucionBecados == null;
    }else {
      return true;
    }
  }

  const downloadFile = async (idDoc, name) => {
    let doc;
    if (idDoc === 1) {
      doc = idAneaesCertificadoInicioProceso;
    } else if (idDoc === 2) {
      doc = idAneaesRespaldoProcesoEvaluacion;
    } else if (idDoc === 3) {
      doc = idAneaesPlanMejoras;
    } else if (idDoc === 4) {
      doc = resolucionHabilitacionMec;
    } else if (idDoc === 5) {
      doc = resolucionAranceles;
    }else if (idDoc === 6) {
      doc = informeSemestralIF;
    }else if (idDoc === 7) {
      doc = resolucionHabilitacionCones;
    }else if (idDoc === 8) {
      doc = constanciaInicioProcesoCones;
    }else if (idDoc === 9) {
      doc = constanciaActualizacionCarreraCones;
    }else if (idDoc === 10) {
      doc = resolucionAcreditacionInicioProcesoAneaes;
    }else if (idDoc === 11) {
      doc = evaluacionDiagnosticaPlanImplementaciónAneaes;
    }else if (idDoc === 12) {
      doc = inscripcionProcesoEvaluaciónAneaes;
    }else if (idDoc === 13) {
      doc = resolucionHabilitacionPostgradoCones;
    }else if (idDoc === 14) {
      doc = constanciaGestionConvenioPostgradoCones;
    }else if (idDoc === 15) {
      doc = certificadoProcesoAcreditacionPostgradoAneaes;
    }else if (idDoc === 16) {
      doc = evaluacionDiagnosticaPostgradoAneaes;
    }else if (idDoc === 17) {
      doc = planImplementacionMejorasPostgradoAneaes;
    } else if (idDoc === 18) {
      doc = resolucionAranceles;
    } else if (idDoc === 19) {
      doc = informeSemestralIF;
    }else if (idDoc === 20) {
      doc = resolucionAranceles;
    }else if (idDoc === 21) {
      doc = informeSemestralIF;
    }else if (idDoc === 22) {
      doc = listadoAlumnos;
    }else if (idDoc === 23) {
      doc = resolucionBecados;
    }

    commonMethods.downloadFile(`/file/${doc}`, `${name}_${new Date()}`, true);
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Paper>
          <Box p={1}>
            <Typography
            variant="h6"
            color="primary"
            align="center"
            className={classes.title}
          >
            Documentos de Respaldo
          </Typography>
          {categoria==="Pregrado" && (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Documento</TableCell>
                  <TableCell align="center">Acción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
             
                {docsRespaldoPregrado.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.descripcion}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Subir" aria-label="subir">
                        <IconButton
                          size="small"
                          aria-label="subir"
                          color="primary"
                          disabled={isAdmin}
                          onClick={() => handleClickOpen(row.id)}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver" aria-label="ver">
                        <>
                          <IconButton
                            size="small"
                            aria-label="ver"
                            color="secondary"
                            disabled={disabledDocumentView(row)}
                            onClick={() => downloadFile(row.id, row.descripcion)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  
                ))}
            
                  <TableRow>
                    <TableCell align="left"  style= {{fontWeight:"bold"}}> <br/> Observaciones  <br/>  </TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left"> 
                    <br/><br/>
                    •  En caso de que cuente con la primera cohorte de egresados de carreras de tecnicatura, deberán presentar la resolución de habilitación de la carrera expedida por el MEC.
                    <br/>
                    <br/>
                    •  En el caso de contar con más de una cohorte, deberá presentar la resolución de renovación de cohortes de las carreras implementadas, vigente al momento de la suscripción del convenio.
                    <br/>
                    <br/>
                    •  En caso de no contar con la Resolución de Habilitación, presentar Constancia que certifique el inicio de proceso de habilitación.
                    <br/>
                    <br/>
                    •  Las Universidades e Institutos Superiores creados por ley y que impartan carreras de tecnicatura superior, también deberán contar con resolución de habilitación del MEC vigente.
                    <br/>
                    <br/>
                   
                    •  Para aquella INSTITUCION FORMADORA que se encuentre en proceso de renovación de cohortes de carreras de tecnicatura superior, deberán presentar la constancia de presentación del proyecto que certifique el inicio del proceso, para la gestión del Convenio.
                    <br/><br/>
                      
                    </TableCell>
                    </TableRow>
                  

              </TableBody>
          
          </Table>         
          )}

          {categoria==="Grado" && (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Documento</TableCell>
                  <TableCell align="right">Acción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                    <TableCell align="left"  style= {{fontWeight:"bold"}}> <br/>CONES</TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                </TableRow>
                {docsRespaldoGradoCones.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.descripcion}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Subir" aria-label="subir">
                        <IconButton
                          size="small"
                          aria-label="subir"
                          color="primary"
                          disabled={isAdmin}
                          onClick={() => handleClickOpen(row.id)}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver" aria-label="ver">
                        <>
                          <IconButton
                            size="small"
                            aria-label="ver"
                            color="secondary"
                            disabled={disabledDocumentView(row)}
                            onClick={() => downloadFile(row.id, row.descripcion)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  
                ))}
                  <TableRow>
                    <TableCell align="left"  style= {{fontWeight:"bold"}}> <br/>Observaciones</TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left"> 
                    <br/>
                    •   Para ambos casos remitir a la DNERHS la copia del acto administrativo que apruebe la habilitación de la carrera, en un plazo no mayor a 4 (cuatro) meses posteriores a la suscripción del convenio. <br/>
                    <br/>
                    </TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left"  style= {{fontWeight:"bold"}}>  <br/>ANEAES  <br/></TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                </TableRow>
                {docsRespaldoGradoAneaes.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.descripcion}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Subir" aria-label="subir">
                        <IconButton
                          size="small"
                          aria-label="subir"
                          color="primary"
                          disabled={isAdmin}
                          onClick={() => handleClickOpen(row.id)}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver" aria-label="ver">
                        <>
                          <IconButton
                            size="small"
                            aria-label="ver"
                            color="secondary"
                            disabled={disabledDocumentView(row)}
                            onClick={() => downloadFile(row.id, row.descripcion)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  
                ))}
                 <TableRow>
                    <TableCell align="left"  style= {{fontWeight:"bold"}}>  <br/>OTROS  <br/></TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                </TableRow>
                {docsRespaldoGradoOtros.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.descripcion}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Subir" aria-label="subir">
                        <IconButton
                          size="small"
                          aria-label="subir"
                          color="primary"
                          disabled={isAdmin}
                          onClick={() => handleClickOpen(row.id)}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver" aria-label="ver">
                        <>
                          <IconButton
                            size="small"
                            aria-label="ver"
                            color="secondary"
                            disabled={disabledDocumentView(row)}
                            onClick={() => downloadFile(row.id, row.descripcion)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  
                ))}
              </TableBody>
            

            </Table>
              )}
          {categoria==="Postgrado" && (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Documento</TableCell>
                  <TableCell align="right">Acción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              <TableRow>
                    <TableCell align="left"  style= {{fontWeight:"bold"}}><br/>CONES</TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                </TableRow>
                {docsRespaldoPostgradoCones.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.descripcion}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Subir" aria-label="subir">
                        <IconButton
                          size="small"
                          aria-label="subir"
                          color="primary"
                          disabled={isAdmin}
                          onClick={() => handleClickOpen(row.id)}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver" aria-label="ver">
                        <>
                          <IconButton
                            size="small"
                            aria-label="ver"
                            color="secondary"
                            disabled={disabledDocumentView(row)}
                            onClick={() => downloadFile(row.id, row.descripcion)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  
                ))}
            <TableRow>
                    <TableCell align="left"  style= {{fontWeight:"bold"}}> <br/>ANEAES</TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                </TableRow>
                {docsRespaldoPostgradoAneaes.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.descripcion}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Subir" aria-label="subir">
                        <IconButton
                          size="small"
                          aria-label="subir"
                          color="primary"
                          disabled={isAdmin}
                          onClick={() => handleClickOpen(row.id)}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver" aria-label="ver">
                        <>
                          <IconButton
                            size="small"
                            aria-label="ver"
                            color="secondary"
                            disabled={disabledDocumentView(row)}
                            onClick={() => downloadFile(row.id, row.descripcion)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  
                ))}
            
            <TableRow>
                    <TableCell align="left"  style= {{fontWeight:"bold"}}>  <br/>OTROS  <br/></TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                </TableRow>
                {docsRespaldoProstgradoOtros.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.descripcion}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Subir" aria-label="subir">
                        <IconButton
                          size="small"
                          aria-label="subir"
                          color="primary"
                          disabled={isAdmin}
                          onClick={() => handleClickOpen(row.id)}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver" aria-label="ver">
                        <>
                          <IconButton
                            size="small"
                            aria-label="ver"
                            color="secondary"
                            disabled={disabledDocumentView(row)}
                            onClick={() => downloadFile(row.id, row.descripcion)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  
                ))}
              </TableBody>
            </Table>
              )}

            <Table>
              <TableBody>
              <TableRow>
                    <TableCell align="left"  style= {{fontWeight:"bold"}}>  <br/>Alumnos<br/></TableCell>
                    <TableCell align="right">
                      
                    </TableCell>
                </TableRow>
                {docsRespaldoAlumnos.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.descripcion}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Subir" aria-label="subir">
                        <IconButton
                          size="small"
                          aria-label="subir"
                          color="primary"
                          disabled={isAdmin}
                          onClick={() => handleClickOpen(row.id)}
                        >
                          <CloudUploadIcon />
                        </IconButton>
                      </Tooltip>
                      <br></br>  
                      <Tooltip title="Ver" aria-label="ver">
                        <>
                          <IconButton
                            size="small"
                            aria-label="ver"
                            color="secondary"
                            disabled={disabledDocumentView(row)}
                            onClick={() => downloadFile(row.id, row.descripcion)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  
                ))}                
              </TableBody>
            </Table>


            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item className={classes.button}>
                <Button
                  variant="contained"
                  color="default"
                  component={Link}
                  to={`/convenios/editar/${params.convenioId}`}
                >
                  Atrás
                </Button>
              </Grid>
              {!isAdmin && (
                <Grid item className={classes.button}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => onSubmit()}
                  >
                    Guardar
                  </Button>
                </Grid>
              )}
            </Grid>
            <AdjuntosDialog
              open={open}
              onClose={handleClose}
              tipoDoc={tipoDoc}
              aria-labelledby="form-dialog-title"
            />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default List;
